import {RouteObject, redirect} from 'react-router';

import {EWebNotificationSection} from '../Notifications';

const children: RouteObject[] = [
  {
    index: true,
    loader: () => redirect(EWebNotificationSection.NOTIFICATIONS),
  },
  {
    path: EWebNotificationSection.NOTIFICATIONS,
    lazy: async () => ({
      Component: (await import('./Tab')).Tab,
    }),
  },
  {
    path: EWebNotificationSection.UPLOADS,
    lazy: async () => ({
      Component: (await import('./Tab')).Tab,
    }),
  },
];

export const notificationsHistoryRoutes: RouteObject = {
  children,
};
